export class ServerError extends Error {
  message =
    'An unexpected error occurred on the server. Please contact us at support@fabscale.com if that keeps happening.';
}
